import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateTotalBasementAreaCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction || !identification) return undefined;

  const {
    basement,
    craftsmanQuality: quality,
    propertyType = 'singleFamilyResidence',
  } = improvementsForTransaction;
  const {
    address: { PostalCode: zipCode },
  } = identification;

  if (
    isUndefined(quality) ||
    (quality * 10) % 1 !== 0 ||
    quality < 1 ||
    isUndefined(zipCode) ||
    !ORDER_FEATURES.basement.hasFeature(improvementsForTransaction)
  ) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  const totalArea =
    basement && basement.totalArea ? AloftArea.schema.parse(basement.totalArea) : AloftArea.zero;

  return calculator.getTotalBasementAreaCost({
    totalArea,
    quality,
    propertyType,
    zipCode,
  });
};

export const {
  selectTotalBasementAreaCost,
  selectZipOnlyBasementAreaCost,
  selectTotalBasementAreaCosts,
  selectTotalBasementAreaCostDisplay,
  selectSubjectTotalBasementAreaCostOutput,
  selectSubjectArvTotalBasementAreaCostOutput,
} = createFeatureCostSelectors({
  calculate: calculateTotalBasementAreaCost,
  inputSelectors: [
    selectCostProps,
    selectImprovementsEntities,
    selectPropertyIdentificationEntities,
  ],
  names: {
    cost: 'selectTotalBasementAreaCost',
    zipOnly: 'selectZipOnlyBasementAreaCost',
    costs: 'selectTotalBasementAreaCosts',
    display: 'selectTotalBasementAreaCostDisplay',
    subjectOutput: 'selectSubjectTotalBasementAreaCostOutput',
    subjectArvOutput: 'selectSubjectArvTotalBasementAreaCostOutput',
  },
});
